import { colors } from "../../../styles/variables";

export const WINE_DETAIL_GUIDE_PRIMARY_TAGS = {
  WINE_STYLE: "main-wine-styles-overview",
  RED_GRAPE_STYLE: "red",
  WHITE_GRAPE_STYLE: "white",
  REGION: "main-wine-countries-and-regions",
  PRODUCTION_METHODS: "clean-and-green",
  HOW_WINE_IS_MADE: "how-wine-is-made-overview",
  SAKE_GUIDES: "sake-guides",
};

export const WINE_GUIDE_SLUGS = {
  OAK: "oak-and-its-uses-in-winemaking",
  PRODUCTION_METHOD_LEES_AND_ORANGE: "winemaking-techniques",
};

export const PRODUCTION_METHOD_NAMES = {
  MATURATION_ON_LEES: "maturation on lees",
  CARBONIC_MACERATION: "carbonic maceration",
};

export const WINE_DETAIL_GUIDE_CARD_TAG_COLOR = {
  WINE_STYLE_RED: colors.purpleThin,
  WINE_STYLE_WHITE: colors.yellow,
  WINE_STYLE_ROSE: colors.pinkTint,
  WINE_STYLE_SPARKLING: colors.blueThin,
  WINE_TYPE_ORANGE: colors.peach,
  RED_GRAPE_STYLE: colors.purpleThin,
  WHITE_GRAPE_STYLE: colors.yellow,
  REGION: colors.blueThin,
  PRODUCTION_METHOD: colors.peach,
};
